import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const NonElligibleIcon = ({ fill='#F66563', border='#000', ...props}) => {
  return (
    <Icon viewBox="0 0 78 72" {...props}>
      <g fill="none">
        <path
          fill={border}
          d="M57.0047,72.0001 L20.9947,72.0001 C19.9267,72.0001 18.9397,71.4001 18.4057,70.4251 L0.4007,37.5751 C-0.1333,36.6011 -0.1333,35.4001 0.4007,34.4261 L18.4057,1.5741 C18.9397,0.6001 19.9267,0.0001 20.9947,0.0001 L57.0047,0.0001 C58.0727,0.0001 59.0597,0.6001 59.5937,1.5741 L77.5997,34.4261 C78.1337,35.4001 78.1337,36.6011 77.5997,37.5751 L59.5937,70.4251 C59.0597,71.4001 58.0727,72.0001 57.0047,72.0001"
        />
        <polygon fill={fill} points="22.721 65.702 55.28 65.702 71.56 36 55.28 6.298 22.721 6.298 6.442 36" />
        <path
          fill={border}
          d="M49.1986,30.2428 C50.2246,29.1658 50.2286,27.4008 49.2066,26.3198 L48.2356,25.2918 C47.2136,24.2108 45.5376,24.2068 44.5116,25.2828 L28.8016,41.7578 C27.7746,42.8338 27.7716,44.5988 28.7936,45.6808 L29.7636,46.7078 C30.7856,47.7898 32.4626,47.7938 33.4886,46.7168 L49.1986,30.2428 Z"
        />
      </g>
    </Icon>
  );
};

NonElligibleIcon.propTypes = {
  fill: PropTypes.string,
  border: PropTypes.string,
};

export default NonElligibleIcon;
